// İSG uzmanı portalı — Ayarlar (Settings) kabuğu (S33 Slice 5, owner kararı — kabuk KENDİ
// Breadcrumb+PageHeader'ını taşır; `docs/plans/S33-carbon-reskin.md` Slice 5, `docs/BACKLOG.md`
// "known exception"ini kapatır). PageHeader'ın sağındaki birincil aksiyon o an AKTİF sekmenin
// kendisidir (`ShellHeaderAction` portal köprüsü — bkz. o dosyanın başlığı). Alt sayfalar (firma/
// şube/saha bilgileri) `Outlet` ile render edilir; `SettingsBranchesPage`/`SettingsSitesPage`
// artık kendi yerel `<h2>`'sini TAŞIMAZ (kabuğun `<h1>`'i TEK gerçek başlık) —
// `SettingsCompanyPage` bu turda DOKUNULMADI (Slice 4'ün "list anatomy" kapsamına hiç
// girmemişti, tek formluk kendi küçük `<h2>` başlığı kalır; `docs/BACKLOG.md`). §9 admin kabuğundan
// (AdminShell) ayrıdır — burası çağıranın KENDİ firmasına kapanmış tenant Ayarlar'ıdır.

import { Breadcrumb, PageHeader } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { RouteTabs } from '../../components/layout/RouteTabs';
import {
  ShellHeaderActionProvider,
  useShellHeaderActionSlot,
} from '../../components/layout/ShellHeaderAction';

export function SettingsShell() {
  const { t } = useTranslation();
  const { slotRef, slot } = useShellHeaderActionSlot();

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={[{ label: t('settings.nav') }]} />
      <PageHeader title={t('settings.nav')} helperText={t('settings.subtitle')} actions={slot} />
      {/* Sekme listesi + gövde ARASINDA boşluk YOK (S33 Slice 6 owner kararı — permit
          detayının "Tabs + Tile bitişik" deseninin (`PermitDetailPage.tsx` dosya başlığı notu)
          RouteTabs kabuklarındaki karşılığı). Dış `gap-6` yalnız Breadcrumb/PageHeader/bu blok
          arasında kalır. */}
      <div className="flex flex-col">
        <RouteTabs
          ariaLabel={t('settings.nav')}
          items={[
            { to: '/settings/company', label: t('settings.tab.company') },
            { to: '/settings/branches', label: t('settings.tab.branches') },
            { to: '/settings/sites', label: t('settings.tab.sites') },
          ]}
        />
        <ShellHeaderActionProvider value={slotRef}>
          <Outlet />
        </ShellHeaderActionProvider>
      </div>
    </div>
  );
}
